import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from '../../service';
import * as _ from 'lodash';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McWhTrackingService {

  constructor(
    private sdk: MycureSDK
  ) {

  }

  async removeAllTracking(orgId: string) {
    const query: any = { warehouse: orgId };
    const item = await this.sdk.warehouse.trackers().find(query);

    const itemIds: string[] = item.items.map((item: any) => item.id);
    await this.sdk.warehouse.trackers().remove({ id: { $in: itemIds } });
  }

  /**
   * Update status tracked variant
   * @param data - { inuse: any, consumed: any }
   */
  async updateVariantStatusTracking(data: any) {
    const { inuse, consumed, warehouse } = data;
    if (!inuse && !inuse.sku) throw new Error('Tracking not found');

    // variant to update
    const sku = inuse.sku;

    // create consumed
    const create: any = { quantity: consumed.quantity, status: 'consumed', sku, warehouse };
    await this.sdk.warehouse.trackers().create(create);
  }

  /**
   * Load Consumed and In-Use tracking of variant
   * @param variant 
   */
  async loadVariantStatusTracking(trackingId: string) {
    const query: any = {
      id: trackingId, $populate: {
        variant: { 
          service: 'wh-variants', key: 'sku',
          $populate: {
            quantity: {
              service: 'wh-stocks', key: 'sku', 
              method: 'findOne', idField: 'variant',
            }
          }
        },
        consumed: {
          service: 'wh-tracking', key: 'sku', method: 'find', 
          idField: 'sku', status: 'consumed'
        }
      }
    };

    const item = await this.sdk.warehouse.trackers().findOne(query)

    let trackingItem = {
      ..._.omit(item, ['$populated']),
      _variant: item.$populated.variant || {},
      _consumed: item.$populated.consumed || []
    };

    if (trackingItem._variant) {
      trackingItem._variant = {
        ..._.omit(trackingItem._variant, ['$populated']),
        _quantity: trackingItem._variant.$populated.quantity || {}
      };
    }
    
    if (trackingItem._consumed) {
      const _totalConsumed: number = trackingItem._consumed
        .map((item: any) => item.quantity || 0)
        .reduce((a: number, x: number) => a + x, 0);
        
      const _totalInUse: number = (trackingItem['quantity'] || 0) - _totalConsumed;

      trackingItem['_totalConsumed'] = _totalConsumed;
      trackingItem['_totalInUse'] = _totalInUse;
    }

    return trackingItem;
  }

  /**
   * Create a tracking document 
   */
  async createTrackingItem(items: any[]) {
    this.sdk.warehouse.trackers().create(items);
  }

  async removeTrackingItem(id: string) {
    return this.sdk.warehouse.trackers().remove(id);
  }

  /**
   * Load all tracking items of an organization
   * @param organization 
   * @param type - tracking type (status, expiration)
   */
  async loadTrackingItems(organization: string, type: string = 'status') {
    let query: any = {
      warehouse: organization,
      $populate: {
        variant: { 
          service: 'wh-variants', key: 'sku',
          $populate: {
            quantity: {
              service: 'wh-stocks', key: 'sku', 
              method: 'findOne', idField: 'variant',
            }
          }
        }
      }
    };

    if (type == 'status') {
      // get all tracking with in-use status
      const $populate = query.$populate || {};
      query = {
        ...query, status: 'in-use',
        $populate: {
          ...$populate, consumed: {
            service: 'wh-tracking', key: 'sku', method: 'find', 
            idField: 'sku', status: 'consumed'
          }
        }
      };
    } else if (type == 'expiration') {
      // get all items with expiration
      query = {
        ...query, expiresAt: { $exists: true }
      }
    }

    const res = await this.sdk.warehouse.trackers().find(query);
    let trackingItems: any[] = res.items;

    trackingItems = trackingItems.map((item: any) => {
      let trackingItem = {
        ..._.omit(item, ['$populated']),
        _variant: item.$populated.variant || {},
        _consumed: item.$populated.consumed || []
      };

      if (trackingItem._variant) {
        trackingItem._variant = {
          ..._.omit(trackingItem._variant, ['$populated']),
          _quantity: trackingItem._variant.$populated.quantity || {}
        };
      }
      
      if (trackingItem._consumed) {
        const _totalConsumed: number = trackingItem._consumed
          .map((item: any) => item.quantity || 0)
          .reduce((a: number, x: number) => a + x, 0);

        const _totalInUse: number = (trackingItem['quantity'] || 0) - _totalConsumed;

        trackingItem['_totalConsumed'] = _totalConsumed;
        trackingItem['_totalInUse'] = _totalInUse;
      }

      return trackingItem;
    });

    return trackingItems;
  }
}
